import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import DataTableSelectionCell from "./DataTableSelectionCell";
import DataTableHeaderCell from "./DataTableHeaderCell";
import { columnPropType } from "./propTypes";
import * as ColumnType from "./ColumnType";
export default class DataTableHeaderRow extends PureComponent {
  static propTypes = {
    columns: PropTypes.arrayOf(columnPropType).isRequired,
    selected: PropTypes.bool,
    onSelectionChange: PropTypes.func,
  };
  renderCell = (column, index) => {
    const { type } = column;
    const { selected, onSelectionChange } = this.props;

    if (type === ColumnType.SELECTION) {
      return <DataTableSelectionCell key={index} column={column} value={selected} onChange={onSelectionChange} />;
    }

    return <DataTableHeaderCell key={index} column={column} />;
  };

  render() {
    const { columns, selected, onSelectionChange, ...otherProps } = this.props;
    return <tr {...otherProps}>{columns.map((item, index) => this.renderCell(item, index))}</tr>;
  }
}
